import { useEffect, useRef } from 'react';

export default function HeroSection() {
  const imgContainerRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleScroll = () => {
      if (imgContainerRef.current) {
        const scrollY = window.scrollY;
        imgContainerRef.current.style.transform = `translateY(${scrollY * 0.35}px)`;
      }
    };
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <section className="relative w-full h-screen overflow-hidden">
      {/* Parallax Hero Image */}
      <div className="absolute inset-0 overflow-hidden">
        <div
          ref={imgContainerRef}
          className="absolute inset-0 h-[130%] -top-[15%]"
        >
          <img
            src="https://storage.readdy-site.link/project_files/16bbb114-aa58-4d3d-8beb-402cd1b38a90/58593bd6-a6f1-41b5-8273-7e40a6162d0f_compressed_Gray-Suit-6.webp"
            alt="Keaton Brown - Baritone"
            className="w-full h-full object-cover object-[66%_50%] md:object-top"
          />
        </div>
      </div>

      {/* Uniform dark overlay */}
      <div className="absolute inset-0 bg-primary-950/35" />

      {/* Gradient fade to next section */}
      <div className="absolute bottom-0 left-0 w-full h-32 bg-gradient-to-t from-primary-950 to-transparent" />

      {/* Text content */}
      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center px-6">
        <h1 className="font-heading text-5xl md:text-6xl lg:text-7xl xl:text-8xl tracking-[0.08em] uppercase text-foreground-50 leading-none animate-[heroTextReveal_1.2s_cubic-bezier(0.25,0.1,0.25,1)_both]">
          Keaton
          <br />
          Brown
        </h1>
        <div className="flex items-center gap-6 mt-8 md:mt-10 animate-[heroTextReveal_1.2s_cubic-bezier(0.25,0.1,0.25,1)_0.35s_both]">
          <span className="block w-10 md:w-16 h-[1px] bg-accent-400/60" />
          <p className="font-body text-base md:text-lg lg:text-xl tracking-[0.25em] uppercase text-foreground-200 font-light">
            Baritone
          </p>
          <span className="block w-10 md:w-16 h-[1px] bg-accent-400/60" />
        </div>
      </div>
    </section>
  );
}